<div class="confirmationDialog">
  <div class="title">{{data.title || 'Confirmation'}}</div>
  <div class="content">
    {{data.message || 'Are you Sure?'}}
  </div>
  <div class="confirmFooter">
    <antim-autoware-button type="button" [label]="data.yesButtonLabel || 'Yes'" btnType="primary"
      (click)="dialogRef.close(1);"></antim-autoware-button>
    <antim-autoware-button (clickEvent)='dialogRef.close(0);' type="button" [label]="data.noButtonLabel || 'NO'"
      btnType="secondary"></antim-autoware-button>
  </div>
</div>